import React from 'react';
import { Clock3, Filter, History, RefreshCw, ShieldAlert } from 'lucide-react';
import { useInfraestruturaData } from '../context/InfraestruturaDataContext';

const noticeBaseClassName =
  'mb-3 flex items-start gap-3 rounded-[16px] border px-3 py-2.5 text-xs leading-5 shadow-[0_8px_22px_rgba(15,23,42,0.08)]';

const InfraEvolutionNotice = () => {
  const {
    hasHistoryFilters,
    evolutionScope,
    evolutionRequestedScope,
    evolutionCacheState,
  } = useInfraestruturaData();

  if (!hasHistoryFilters) {
    return (
      <div className={`${noticeBaseClassName} border-[color:var(--header-control-border-subtle)] bg-[color:var(--surface-muted)]/55 text-[color:var(--text-muted)]`}>
        <History className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--accent)]/85" />
        <div>
          <p className="font-medium text-[color:var(--text-primary)]">Histórico geral</p>
          <p>Sem filtros históricos ativos. A série mostra a base consolidada dos últimos 12 meses.</p>
        </div>
      </div>
    );
  }

  if (evolutionRequestedScope === 'filtered' && evolutionScope === 'filtered') {
    return (
      <div className={`${noticeBaseClassName} border-emerald-500/20 bg-emerald-500/10 text-[color:var(--text-muted)]`}>
        <Filter className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
        <div>
          <p className="font-medium text-[color:var(--text-primary)]">Histórico filtrado ativo</p>
          <p>Os dados históricos já refletem os filtros cruzados selecionados na dashboard.</p>
        </div>
      </div>
    );
  }

  if (evolutionRequestedScope === 'filtered' && evolutionScope === 'general' && evolutionCacheState === 'warming') {
    return (
      <div className={`${noticeBaseClassName} border-amber-500/25 bg-amber-500/12 text-[color:var(--text-muted)]`}>
        <RefreshCw className="mt-0.5 h-4 w-4 shrink-0 animate-spin text-amber-300" />
        <div>
          <p className="font-medium text-[color:var(--text-primary)]">Mostrando histórico geral temporariamente</p>
          <p>O histórico filtrado ainda está sendo processado. Assim que ficar pronto, este gráfico será atualizado automaticamente.</p>
        </div>
      </div>
    );
  }

  if (evolutionRequestedScope === 'filtered' && evolutionScope === 'general' && evolutionCacheState === 'timeout') {
    return (
      <div className={`${noticeBaseClassName} border-rose-500/20 bg-rose-500/10 text-[color:var(--text-muted)]`}>
        <Clock3 className="mt-0.5 h-4 w-4 shrink-0 text-rose-300" />
        <div>
          <p className="font-medium text-[color:var(--text-primary)]">Histórico filtrado demorou para responder</p>
          <p>Seguimos exibindo o histórico geral para não interromper a análise. Tente novamente em alguns instantes.</p>
        </div>
      </div>
    );
  }

  if (evolutionRequestedScope === 'filtered' && evolutionScope === 'general' && evolutionCacheState === 'error') {
    return (
      <div className={`${noticeBaseClassName} border-rose-500/20 bg-rose-500/10 text-[color:var(--text-muted)]`}>
        <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-rose-300" />
        <div>
          <p className="font-medium text-[color:var(--text-primary)]">Fallback para histórico geral</p>
          <p>Não foi possível carregar o histórico filtrado agora. O gráfico permanece com a série geral da operação.</p>
        </div>
      </div>
    );
  }

  return null;
};

export default InfraEvolutionNotice;
